import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import {
  EKwikUIButtonApiCallTimerType,
  TKwikUIButtonApiCallTimer
} from "./button-api-call.definitions";

@Injectable({
  providedIn: "root"
})
export class KwikUIButtonApiCallTimerService {
  private timerSource = new BehaviorSubject<string>(null);

  timer$ = this.timerSource.asObservable();

  private stopTimerSource = new BehaviorSubject<boolean>(false);

  stopTimer$ = this.stopTimerSource.asObservable();

  private timerInterval: any;

  startTimer({
    maxTime = 0,
    timerChangeType,
    timerStep = 1
  }: TKwikUIButtonApiCallTimer) {
    if (
      maxTime <= 0 ||
      typeof maxTime !== "number" ||
      typeof timerStep !== "number"
    ) {
      this.stopTimer();
      return;
    }

    this.stopTimerSource.next(false);
    if (timerChangeType == EKwikUIButtonApiCallTimerType.INCREMENT) {
      let currentTime = 0;
      this.timerInterval = setInterval(() => {
        if (currentTime >= maxTime) {
          this.stopTimer();
        } else {
          currentTime += timerStep;
          this.timerSource.next(String(currentTime));
        }
      }, timerStep * 1000);
    } else if (timerChangeType == EKwikUIButtonApiCallTimerType.DECREMENT) {
      let currentTime = maxTime;
      this.timerInterval = setInterval(() => {
        if (currentTime <= 0) {
          this.stopTimer();
        } else {
          currentTime -= timerStep;
          this.timerSource.next(String(currentTime));
        }
      }, timerStep * 1000);
    } else {
      this.stopTimer();
    }
  }

  stopTimer() {
    clearInterval(this.timerInterval);
    this.timerSource.next(undefined);
    this.stopTimerSource.next(true);
  }
}
